export const SETTINGS_TABS = [
  { id: 'user', label: 'Χρήστες', icon: '👥' },    
  { id: "profile", label: "Προφίλ & Στοιχεία", icon: "👤" },
  { id: "notifications", label: "Ειδοποιήσεις", icon: "🔔" },
  { id: "security", label: "Ασφάλεια", icon: "🔒" },
  { id: "data", label: "Προσωπικά Δεδομένα GDPR", icon: "💾" },
  { id: "theme", label: "Θέμα & Εμφάνιση", icon: "🎨" },
  { id: "change-password", label: "Αλλαγή Κωδικού", icon: "🔑" },
] as const;

export type TabId = typeof SETTINGS_TABS[number]['id'];